export default "/images/qr-code.svg?ba4497380efe94e3a9066c081fc5e874";